// Import all JS files here
import '../../node_modules/jquery-once/jquery.once.min';
import './global-navigation';
import './hero-video';
import './find-a-course';
import './pager';
import './instructors';
import './info-popup';
import './custom-chosen';
import './splide';
import './stats';
import './table-scroll';
import './video-modal';

(function(jQuery, Drupal) {
  'use strict';
  // 9 times out of 10 it's probably better to make a new file
  // instead of writing code in here.
})(jQuery, Drupal);
